// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.responder[data-v-3cf00128] {\n\ttext-align: center;\n\tpadding: 50px;\n\tfont-size: 20px;\n}\n.deny[data-v-3cf00128],\n.error[data-v-3cf00128] {\n\tcolor: #c00;\n}\n.approve[data-v-3cf00128] {\n\tcolor: #090;\n}\n.return-link[data-v-3cf00128] {\n\tmargin-top: 20px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
